import React, { useEffect, useState, useMemo } from 'react';

import { Link } from 'react-router-dom';

import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import SearchIcon from '@material-ui/icons/Search';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import EditIcon from '@material-ui/icons/Edit';
import CardContent from '@material-ui/core/CardContent';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete'; 
import AddBoxIcon from '@material-ui/icons/AddBox';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';

import { green, red } from '@material-ui/core/colors';

import RoutesService from './../../../services/api/routes';

import { TableSelectable } from '../../Common/Table/table_selectable.js'

import { useStyles } from './styles';
import VehiclesModal from '../VehiclesModal';

export const RoutesList = () => {

  const classes = useStyles();

  const [routes, setRoutes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState();
  const [searchResults, setSearchResults] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteBtnDisabled, setDeleteBtnDisabled] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState();

  const [dialogVehiclesVisible, setDialogVehiclesVisible] = useState(false);

  const columns = useMemo(() => [
    {
      Header: 'ID',
      accessor: 'RutaID',
    },
    {
      Header: 'NOMBRE',
      accessor: 'Nombre',
    },
    {
      Header: 'UNIDADES',
      accessor: (d) => {
        return <>
          {d.UnidadesPreview.map(item => (
            <Chip
              icon={<CheckIcon style={{ color: green[700] }} />}
              label={item.Numero}
              className={classes.chipVehicle}
            />
          ))}
          &nbsp;
          <Tooltip title="Ver detalle">
            <IconButton
              color="secondary"
              size="small"
              onClick={() => {
                setDialogVehiclesVisible(true)
                setSelectedRoute(d.RutaID)
              }}
              aria-label="see detail"
            >
              <AirportShuttleIcon />
            </IconButton>
          </Tooltip>
        </>;
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'ESTADO',
      accessor: (d) => {
        return (
          d ? 
          <Chip
            icon={<CheckIcon style={{ color: green[700] }} />}
            label="Activa"
            className={classes.chipActive}
          />
          :
          <Chip
            icon={<CloseIcon style={{ color: red[700] }} />}
            label="Inactiva"
            className={classes.chipInactive}
          />
        )
      },
      style: {
        textAlign: 'center',
      },
    },
    {
      Header: 'ACCIONES',
      accessor: (d) => {
        return (
          <>
            <Tooltip title="Ver detalle">
              <IconButton
                color="secondary"
                size="small"
                href={`/routes/detail/${d.RutaID}`}
                aria-label="see detail"
              >
                <ZoomInIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar">
              <IconButton
                color="secondary"
                size="small"
                href={`/routes/edit/${d.RutaID}`}
                aria-label="edit route"
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      style: {
        textAlign: 'center',
      },
    },
  ], []);

  useEffect(() => {
    fetchRoutes();
  }, []);

  const fetchRoutes = () => {
    RoutesService.getList()
      .then((response) => {
        if (response === null || !response.IsValid) {
          throw response.Message;
        }
        //Get Routes
        if (response && response.Data && response.Data.length > 0) {
          setRoutes(response.Data);
          setIsLoading(false);
          setShowDelete(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  }

  const handleSearch = () => {
    const results = routes.filter(item => item.Nombre.toLowerCase().includes(search.toLowerCase()))
    setSearchResults(results);
  };

  const handleRowSelection = (rows) => {
    if (Object.keys(rows).length) {
      // Show Button
      setShowDelete(true);
      setSelectedRows(rows);
    } else {
      setShowDelete(false);
    }
  }

  const deleteBatchRoutes = () => {
    //
    if (!selectedRows) {
      return;
    };

    // setIsLoading(true);
    // setPassengers([]);
    // setDeleteBtnDisabled(true);
    // UsersServices.deletePassengerBatch(selectedRows)
    //   .then((response) => {
    //     if (response === null || !response.IsValid) {
    //       throw response.Message;
    //     }
    //     if (response.IsValid && response.Data !== undefined) {
    //       fetchPassengers();
    //       setDialogVisible(false);
    //       setDeleteBtnDisabled(false);
    //     } else {
    //       throw response.Message;
    //     }
    //   })
    //   .catch((error) => {
    //     setIsLoading(false);
    //     console.error(error);
    //   });
  };

  return (
    <React.Fragment>
      <Grid container className={classes.header} direction="column">
        <Grid item sm={12} xs={12} className={classes.filterBox}>
          <Card className={classes.card}>
            <CardContent>
              <Grid container className={classes.header} direction="row" justifyContent="space-between">
                <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                  <Paper elevation={1} className={classes.paper}>
                    <SearchIcon className={classes.searchIcon} />
                    <InputBase onChange={ event => setSearch(event.target.value)} placeholder="Buscar" className={classes.searchInput} />
                    <Divider className={classes.divider} orientation="vertical" />
                    <Button
                      fullWidth
                      size="small"
                      variant="contained"
                      color="secondary"
                      className={classes.filterBtn}
                      startIcon={<SearchIcon />}
                      onClick={handleSearch}
                    >
                      Buscar
                    </Button>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                  { showDelete && 
                    <IconButton 
                      onClick={() => setDialogVisible(true)}
                      aria-label="delete" 
                      className={classes.deleteIcon} 
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                  <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.actionBtn}
                    startIcon={<AddBoxIcon />}
                    component={Link}
                    to="/routes/create"
                  >
                    Crear Nueva Ruta
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item sm={12} xs={12}>
          <TableSelectable
            columns={columns}
            data={searchResults.length > 0 ? searchResults : routes}
            isLoading={isLoading}
            rowSelection={handleRowSelection}
          />
        </Grid>
      </Grid>
      <Dialog
        open={dialogVisible}
        onClose={() => setDialogVisible(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Esta seguro que desea eliminar estas Rutas?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogVisible(false)} color="primary">
            Cancelar
          </Button>
          <Button disabled={deleteBtnDisabled} onClick={deleteBatchRoutes} color="primary" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogVehiclesVisible}
        onClose={() => setDialogVehiclesVisible(false)}
        aria-labelledby="alert-dialog-vehicles-title"
        aria-describedby="alert-dialog-vehicles-description"
        fullWidth={false}
        maxWidth={'lg'}
      >
        <DialogTitle id="alert-dialog-vehicles-title">
          {'Asignacion de Unidades'}
        </DialogTitle>
        <DialogContent>
          <VehiclesModal selectedRoute={selectedRoute}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            fetchRoutes();
            setDialogVehiclesVisible(false)
          }} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
